import { NgModule } from "@angular/core";

import { CommonModule as NgCommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { ServicesListComponent } from "./all/services-list.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from '@ngx-translate/core';

import { AuthGuardService as AuthGuard } from "../../services/auth-guard";
import { CommonModule } from "src/app/common/common.module";
import { OsheeSearchComponent } from "./search/oshee/oshee-search.component";
import { DoganaSearchComponent } from "./search/dogana/dogana-search.component";
import { GjobaSearchComponent } from "./search/gjoba/gjoba-search.component";
import { UkSearchComponent } from "./search/uk/uk-search.component";
import { ModalPaymentContentComponent } from "./modal-payment-content/modal-payment-content.component";
import { TatimeSearchComponent } from "./search/tatime/tatime-search.component";
import { ModalTatimeAmountComponent } from "./search/tatime/modal-amount/modal-tatime-amount.component";
import { AlbtelecomComponent } from "./search/albtelecom/albtelecom.component";
import { OneComponent } from "./search/one/one.component";
import { AlbtelecomListOfOffersComponent } from "./search/albtelecom/albtelecom-list-of-offers/albtelecom-list-of-offers.component";
import { OneListOfOffersComponent } from "./search/one/one-list-of-offers/one-list-of-offers.component";
import { OneServiceComponent } from "./search/one/one-service.component";
import { KindergardenComponent } from "./search/kindergarden/kindergarden.component";
import { AlbtelecomContractComponent } from "./search/albtelecom-contract/albtelecom-contract.component";
import { AlbtelecomServiceComponent } from "./search/albtelecom-service/albtelecom-service.component";

import { environment } from "src/environments/environment";
import { env } from "process";

const staticRoutes: Routes = [
  {
    path: "services",
    component: ServicesListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/oshee",
    component: OsheeSearchComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/oshee/:customerNumber",
    component: OsheeSearchComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/oshee/:customerNumber/:isAktMarreveshje",
    component: OsheeSearchComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/oshee/:customerNumber/:isAktMarreveshje/:contractNumber",
    component: OsheeSearchComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/oshee/:customerNumber/:isAktMarreveshje/:contractNumber/:city",
    component: OsheeSearchComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/ukt",
    component: UkSearchComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/ukt/:contractNumber/:institutionCode",
    component: UkSearchComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/gjoba",
    component: GjobaSearchComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/gjoba/:plate",
    component: GjobaSearchComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/one",
    component: OneServiceComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/oneservice",
    component: OneComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/one/:mobileNumber",
    component: OneComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/albtelecom",
    component: AlbtelecomComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/albtelecom/:mobileNumber",
    component: AlbtelecomComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/albtelecomcontract",
    component: AlbtelecomContractComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/albtelecomcontract/:params",
    component: AlbtelecomContractComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/albtelecomservice",
    component: AlbtelecomServiceComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/albtelecomservice/:params",
    component: AlbtelecomServiceComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/alb",
    component: AlbtelecomServiceComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/alb/:params",
    component: AlbtelecomServiceComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/kindergarden",
    component: KindergardenComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/kindergarden/:params",
    component: KindergardenComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/dogana",
    component: DoganaSearchComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/dogana/:barcode",
    component: DoganaSearchComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/tatime",
    component: TatimeSearchComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "services/tatime/:serialNumber",
    component: TatimeSearchComponent,
    canActivate: [AuthGuard]
  },


];

// const OSEERoutes = [
//   {
//     path: "services/oshee",
//     component: OsheeSearchComponent,
//     canActivate: [AuthGuard]
//   },
//   {
//     path: "services/oshee/:customerNumber",
//     component: OsheeSearchComponent,
//     canActivate: [AuthGuard]
//   },
//   {
//     path: "services/oshee/:customerNumber/:isAktMarreveshje",
//     component: OsheeSearchComponent,
//     canActivate: [AuthGuard]
//   },
//   {
//     path: "services/oshee/:customerNumber/:isAktMarreveshje/:contractNumber",
//     component: OsheeSearchComponent,
//     canActivate: [AuthGuard]
//   },
//   {
//     path: "services/oshee/:customerNumber/:isAktMarreveshje/:contractNumber/:city",
//     component: OsheeSearchComponent,
//     canActivate: [AuthGuard]
//   }
// ]

// const UKRoutes = [
//   {
//     path: "services/ukt",
//     component: UkSearchComponent,
//     canActivate: [AuthGuard]
//   },
//   {
//     path: "services/ukt/:contractNumber/:institutionCode",
//     component: UkSearchComponent,
//     canActivate: [AuthGuard]
//   }
// ]

// const GJOBATRoutes = [
//   {
//     path: "services/gjoba",
//     component: GjobaSearchComponent,
//     canActivate: [AuthGuard]
//   },
//   {
//     path: "services/gjoba/:plate",
//     component: GjobaSearchComponent,
//     canActivate: [AuthGuard]
//   },
// ]

// const ONERoutes = [
//   {
//     path: "services/one",
//     component: OneComponent,
//     canActivate: [AuthGuard]
//   },
//   {
//     path: "services/one/:mobileNumber",
//     component: OneComponent,
//     canActivate: [AuthGuard]
//   }
// ]

// const ALBTELECOMRoutes = [
//   {
//     path: "services/albtelecom",
//     component: AlbtelecomComponent,
//     canActivate: [AuthGuard]
//   },
//   {
//     path: "services/albtelecom/:mobileNumber",
//     component: AlbtelecomComponent,
//     canActivate: [AuthGuard]
//   },
//   {
//     path: "services/albtelecomcontract",
//     component: AlbtelecomContractComponent,
//     canActivate: [AuthGuard]
//   },
//   {
//     path: "services/albtelecomcontract/:params",
//     component: AlbtelecomContractComponent,
//     canActivate: [AuthGuard]
//   },
//   {
//     path: "services/albtelecomservice",
//     component: AlbtelecomServiceComponent,
//     canActivate: [AuthGuard]
//   },
//   {
//     path: "services/albtelecomservice/:params",
//     component: AlbtelecomServiceComponent,
//     canActivate: [AuthGuard]
//   },
//   {
//     path: "services/alb",
//     component: AlbtelecomServiceComponent,
//     canActivate: [AuthGuard]
//   },
//   {
//     path: "services/alb/:params",
//     component: AlbtelecomServiceComponent,
//     canActivate: [AuthGuard]
//   }
// ]

// const KOPSHTERoutes = [
//   {
//     path: "services/kindergarden",
//     component: KindergardenComponent,
//     canActivate: [AuthGuard]
//   },
//   {
//     path: "services/kindergarden/:params",
//     component: KindergardenComponent,
//     canActivate: [AuthGuard]
//   },
// ]

// const DOGANARoutes = [
//   {
//     path: "services/dogana",
//     component: DoganaSearchComponent,
//     canActivate: [AuthGuard]
//   },
//   {
//     path: "services/dogana/:barcode",
//     component: DoganaSearchComponent,
//     canActivate: [AuthGuard]
//   },
// ]

// const TATIMERoutes = [
//   {
//     path: "services/tatime",
//     component: TatimeSearchComponent,
//     canActivate: [AuthGuard]
//   },
//   {
//     path: "services/tatime/:serialNumber",
//     component: TatimeSearchComponent,
//     canActivate: [AuthGuard]
//   },
// ]

let routes = staticRoutes
// if (environment.showServiceOSHEE) {
//   routes = routes.concat(OSEERoutes)
// }

// if (environment.showServiceUK) {
//   routes = routes.concat(UKRoutes)
// }

// if (environment.showServiceGJOBAT) {
//   routes = routes.concat(GJOBATRoutes)
// }

// if (environment.showServiceONE) {
//   routes = routes.concat(ONERoutes)
// }

// if (environment.showServiceALBTELECOM) {
//   routes = routes.concat(ALBTELECOMRoutes)
// }

// if (environment.showServiceKOPSHTE) {
//   routes = routes.concat(KOPSHTERoutes)
// }

// if (environment.showServiceDOGANA) {
//   routes = routes.concat(DOGANARoutes)
// }

// if (environment.showServiceTATIME) {
//   routes = routes.concat(TATIMERoutes)
// }


@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgCommonModule,
        RouterModule.forChild(routes),
        CommonModule,
        TranslateModule
    ],
    declarations: [
        ServicesListComponent,

        // payment modal (all services included)
        ModalPaymentContentComponent,
        ModalTatimeAmountComponent,

        // SEARCH
        OsheeSearchComponent,
        DoganaSearchComponent,
        UkSearchComponent,
        GjobaSearchComponent,
        TatimeSearchComponent,
        AlbtelecomComponent,
        OneComponent,
        AlbtelecomListOfOffersComponent,
        OneListOfOffersComponent,
        KindergardenComponent,
        AlbtelecomContractComponent,
        AlbtelecomServiceComponent,
        OneServiceComponent
    ],
    exports: [
      TranslateModule
    ]
})
export class KerkimSherbimeModule {
}
